import api from "../api/api";
import { whatZapService } from "./whatZapService"; // ✅ Importar whatZapService
const BASE_URL = import.meta.env.VITE_APP_API_URL;

export const chamadosService = {
  obterTodos: async (params) => {
    try {
      const url = `${BASE_URL}/chamado-consulta`;
      const response = await api.get(url, { params });
      return response.data;
    } catch (error) {
      console.error("Erro ao obter chamados:", error);
      throw new Error("Erro ao obter chamados.");
    }
  },

  ConsultaPorIdChamado: async (id) => {
    try {
      const url = `${BASE_URL}/chamado-consulta-id/${id}`;
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error("Erro ao obter chamado por id:", error);
      throw new Error("Erro ao obter chamado por id.");
    }
  },

  consultaTipoManutencao: async (params) => {
    try {
      const url = `${BASE_URL}/tipo-manutencao-maquinas`;
      const response = await api.get(url, { params });
      return response.data;
    } catch (error) {
      console.error("Erro ao obter tipos de manutenção:", error);
      throw new Error("Erro ao obter tipos de manutenção.");
    }
  },

  consultaMecanicos: async (params) => {
    try {
      const url = `${BASE_URL}/mecanicos`;
      const response = await api.get(url, { params });
      return response.data;
    } catch (error) {
      console.error("Erro ao obter mecânicos:", error);
      throw new Error("Erro ao obter mecânicos.");
    }
  },

  consultaMaquina: async (id) => {
    try {
      const url = `${BASE_URL}/maquinas/${id}/ficha-completa`;
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error("Erro ao obter maquina por id:", error);
      throw new Error("Erro ao obter maquina por id.");
    }
  },

  abrirChamado: async (chamado) => {
    try {
      const url = `${BASE_URL}/chamados/incluir-abertura`;
      const response = await api.post(url, chamado);
      return response.data;
    } catch (error) {
      handleError(error, "Erro ao abrir chamado.");
    }
  },

  chamadoIniciarTrabalho: async (chamadoData) => {
    try {
      const url = `${BASE_URL}/chamados/chamado-iniciar-trabalho/${chamadoData.id_chamado}`;
      return await api.post(url, { id_chamado: chamadoData.id_chamado });
    } catch (error) {
      handleError(error, "Erro ao iniciar trabalho do chamado.");
      throw error;
    }
  },

  chamadoExecucaoCurso: async (chamadoData) => {
    try {
      const url = `${BASE_URL}/chamados/chamado-execucao-curso/${chamadoData.id_chamado}`;
      return await api.post(url, {
        observacao_mecanico: chamadoData.observacao_mecanico,
      });
    } catch (error) {
      handleError(error, "Erro ao atualizar execução em curso.");
      throw error;
    }
  },

  chamadoFinalizar: async (chamadoData) => {
    try {
      const url = `${BASE_URL}/chamados/chamado-finalizar/${chamadoData.id_chamado}`;
      return await api.post(url, {
        observacao_encerramento: chamadoData.observacao_encerramento,
        id_status_chamado: chamadoData.id_status_chamado,
      });
    } catch (error) {
      handleError(error, "Erro ao finalizar o chamado.");
      throw error;
    }
  },

  chamadoAdicionarMecanico: async (chamadoData) => {
    try {
      const url = `${BASE_URL}/chamados/chamado-adicionar-mecanico/${chamadoData.id_chamado}`;
      return await api.post(url, { id_mecanico: chamadoData.id_mecanico });
    } catch (error) {
      handleError(error, "Erro ao adicionar mecânico ao chamado.");
      throw error;
    }
  },

  chamadoCancelar: async (chamadoData) => {
    try {
      const url = `${BASE_URL}/chamados/chamado-cancelar/${chamadoData.id_chamado}`;
      return await api.post(url, {
        observacao_Cancelamento: chamadoData.observacao_Cancelamento,
      });
    } catch (error) {
      handleError(error, "Erro ao cancelar chamado.");
      throw error;
    }
  },

  // ✅ MÉTODOS WHATSAPP ADICIONADOS

  /**
   * Verificar status do WhatsApp
   * @param {Object} params - Parâmetros com empresa_id
   * @returns {Promise<Object>} - Resposta da API
   */
  verificarStatusWhatsapp: async (params) => {
    try {
      return await whatZapService.verificarStatusWhatsapp(params);
    } catch (error) {
      console.error("Erro ao verificar status WhatsApp:", error);
      throw error;
    }
  },

  /**
   * Enviar mensagem via WhatsApp com validação e verificação de status
   * @param {Object} dados - Dados da mensagem
   * @returns {Promise<Object>} - Resposta da API
   */
  enviarWhatsapp: async (dados) => {
    try {
      // ✅ VALIDAR DADOS ANTES DO ENVIO
      const validacao = whatZapService.validarDadosEnvio(dados);
      if (!validacao.valido) {
        throw new Error(`Dados inválidos: ${validacao.erros.join(', ')}`);
      }

      // ✅ FORMATAR TELEFONE
      const dadosFormatados = {
        ...dados,
        telefone: whatZapService.formatarTelefone(dados.telefone)
      };

      // ✅ ENVIAR VIA WHATZAPSERVICE
      return await whatZapService.enviarWhatsapp(dadosFormatados);
    } catch (error) {
      console.error("Erro ao enviar WhatsApp:", error);
      throw error; // Propagar erro original para melhor tratamento
    }
  },

  /**
   * Enviar múltiplas mensagens com verificação de status
   * @param {Array} destinatarios - Lista de destinatários
   * @param {string} mensagem - Texto da mensagem
   * @param {number} empresa_id - ID da empresa
   * @returns {Promise<Array>} - Resultados dos envios
   */
  enviarWhatsappMultiplo: async (destinatarios, mensagem, empresa_id = 1) => {
    try {
      // ✅ VERIFICAR STATUS ANTES DE ENVIAR
      const statusCheck = await whatZapService.verificarStatusWhatsapp({
        empresa_id
      });

      const statusInstancia = statusCheck?.data?.response?.instance?.state;
      
      if (statusInstancia !== 'open') {
        const config = whatZapService.getConfigErroConexao(
          statusInstancia, 
          statusCheck?.data?.response?.instance?.instanceName
        );
        throw new Error(`${config.titulo}: ${config.texto}`);
      }

      // ✅ ENVIAR PARA CADA DESTINATÁRIO
      const resultados = [];
      
      for (const destinatario of destinatarios) {
        try {
          const dados = {
            texto: mensagem,
            telefone: destinatario.celular || destinatario.telefone,
            empresa_id
          };

          const response = await this.enviarWhatsapp(dados);
          
          resultados.push({
            pessoa: destinatario.nome,
            telefone: dados.telefone,
            status: "✅ Enviado com sucesso",
            detalhes: response?.data?.message || "Mensagem processada",
            response: response?.data
          });

        } catch (error) {
          resultados.push({
            pessoa: destinatario.nome,
            telefone: destinatario.celular || destinatario.telefone,
            status: "❌ Erro no envio",
            detalhes: error.message || "Erro desconhecido",
            error: error
          });
        }

        // ✅ AGUARDAR ENTRE ENVIOS
        await whatZapService.aguardar(3);
      }

      return resultados;

    } catch (error) {
      console.error("Erro no envio múltiplo:", error);
      throw error;
    }
  },

  /**
   * Desconectar WhatsApp
   * @param {Object} params - Parâmetros com empresa_id
   * @returns {Promise<Object>} - Resposta da API
   */
  desconectarWhatsapp: async (params) => {
    try {
      return await whatZapService.desconectarWhatsapp(params);
    } catch (error) {
      console.error("Erro ao desconectar WhatsApp:", error);
      throw error;
    }
  },

  /**
   * Gerar QR Code para WhatsApp
   * @param {Object} params - Parâmetros com empresa_id
   * @returns {Promise<Object>} - Resposta da API com QR Code
   */
  gerarQrCodeWhatsapp: async (params) => {
    try {
      return await whatZapService.gerarQrcode(params);
    } catch (error) {
      console.error("Erro ao gerar QR Code:", error);
      throw error;
    }
  },

  /**
   * Verificar se WhatsApp está conectado
   * @param {Object} params - Parâmetros com empresa_id
   * @returns {Promise<boolean>} - True se conectado
   */
  isWhatsappConectado: async (params) => {
    try {
      return await whatZapService.isWhatsappConectado(params);
    } catch (error) {
      console.error("Erro ao verificar conexão WhatsApp:", error);
      return false;
    }
  },

  /**
   * Obter informações da instância WhatsApp
   * @param {Object} params - Parâmetros com empresa_id
   * @returns {Promise<Object>} - Informações da instância
   */
  getInfoInstanciaWhatsapp: async (params) => {
    try {
      return await whatZapService.getInfoInstancia(params);
    } catch (error) {
      console.error("Erro ao obter info da instância:", error);
      throw error;
    }
  },

  /**
   * Verificar saúde da API WhatsApp
   * @returns {Promise<Object>} - Status da API
   */
  verificarSaudeWhatsapp: async () => {
    try {
      return await whatZapService.verificarSaudeAPI();
    } catch (error) {
      console.error("Erro ao verificar saúde da API:", error);
      throw error;
    }
  },

  /**
   * Obter estatísticas de uso do WhatsApp
   * @param {Object} params - Parâmetros com empresa_id
   * @returns {Promise<Object>} - Estatísticas de uso
   */
  obterEstatisticasWhatsapp: async (params) => {
    try {
      return await whatZapService.obterEstatisticas(params);
    } catch (error) {
      console.error("Erro ao obter estatísticas:", error);
      throw error;
    }
  },

  // ✅ MÉTODOS AUXILIARES PARA WHATSAPP

  /**
   * Preparar mensagem de chamado para WhatsApp
   * @param {Object} chamado - Dados do chamado
   * @returns {string} - Mensagem formatada
   */
  prepararMensagemChamado: (chamado) => {
    return `
**Chamado Nº ${chamado.id}**

**Tipo Manutenção:**
${chamado.tipo_manutencao?.tipo_manutencao || 'N/A'}

**Chefe de Setor:**
${chamado.funcionario_abertura?.nome || 'N/A'}

**Máquina:**
#${chamado.maquina?.id} - ${chamado.maquina?.descricao_maquina || 'N/A'}

**Modelo:**
${chamado.maquina?.modelo || 'N/A'}

**Setor:**
${chamado.setor?.descricao_setor || 'N/A'}

**Prioridade:**
${chamado.prioridade?.prioridade || 'N/A'}

**Localização:**
Fila ${chamado.maquina?.fila || 'N/A'} - Posição ${chamado.maquina?.posicao || 'N/A'}

**Observação:**
${chamado.observacao_abertura || "Sem observações"}

---
Sistema de Chamados - ${new Date().toLocaleString('pt-BR')}
    `.trim();
  },

  /**
   * Obter destinatários para envio de WhatsApp
   * @param {Object} chamado - Dados do chamado
   * @returns {Array} - Lista de destinatários
   */
  obterDestinatariosWhatsapp: (chamado) => {
    const destinatarios = [];

    if (chamado.tipo_manutencao?.robos) {
      chamado.tipo_manutencao.robos.forEach((robo) => {
        if (robo.funcionarios_whatsapp && Array.isArray(robo.funcionarios_whatsapp)) {
          destinatarios.push(
            ...robo.funcionarios_whatsapp
              .filter(funcionario => funcionario.celular) // Só incluir quem tem celular
              .map(funcionario => ({
                ...funcionario,
                selecionado: true
              }))
          );
        }
      });
    }

    // Remover duplicados baseado no ID
    return destinatarios.filter(
      (item, index, self) => index === self.findIndex(t => t.id === item.id)
    );
  }
};

// ✅ FUNÇÃO AUXILIAR MELHORADA PARA TRATAR ERROS
function handleError(error, mensagemPadrao) {
  console.error("Erro capturado:", error);

  if (error.response) {
    // Erro de resposta HTTP
    const status = error.response.status;
    const data = error.response.data;

    switch (status) {
      case 400:
        throw new Error(data.message || "Dados inválidos enviados.");
      case 401:
        throw new Error("Não autorizado. Verifique suas credenciais.");
      case 403:
        throw new Error("Acesso negado. Você não tem permissão.");
      case 404:
        throw new Error("Recurso não encontrado.");
      case 408:
        throw new Error("Timeout na conexão. Tente novamente.");
      case 422:
        throw new Error(data.message || "Dados não processáveis.");
      case 500:
        throw new Error("Erro interno do servidor. Tente novamente mais tarde.");
      case 503:
        throw new Error("Serviço temporariamente indisponível.");
      default:
        throw new Error(data.message || mensagemPadrao);
    }
  } else if (error.request) {
    // Erro de rede
    throw new Error("Erro de rede. Verifique sua conexão com a internet.");
  } else {
    // Erro de configuração ou outro
    throw new Error(error.message || mensagemPadrao);
  }
}